import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import Modal from "react-bootstrap/Modal";
import { Get_test } from "../../gql/queries";
import { Bookmark_QB } from "../../gql/mutation";
import { useMutation, useQuery } from "@apollo/client";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
export default function TestAllSolution() {
    const navigate = useNavigate()

    const [filter, applyFilter] = useState(false);
    let [all, setAll] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [remoteLoading, setRemoteLoading] = useState(true);
    let location = useLocation();
    const [selectData, setData] = useState(JSON.parse(location.state));
    const [attempted, setAttempted] = useState(true);
    const [subject, setSubject] = useState(false);
    const [topic, setTopic] = useState(false);
    const [apply, setapply] = useState([]);
    // const [alltopic, setAllTopic] = useState(false);
    const [allsubject, setAllSubject] = useState(true);
    const [subjectArr, setSubjectArr] = useState([]);
    const [TopicArr, setTopicArr] = useState([]);
    const [unattempted, setUnattempted] = useState(true);
    const [correct, setCorrect] = useState(true);
    const [incorrect, setIncorrect] = useState(true);
    const [guess, setGuess] = useState(true);
    const [review, setReview] = useState(true);
    const showFilter = () => applyFilter(true);
    const hideFilter = () => applyFilter(false);
    let { id } = useParams()
    let showData = false
    let count = 0
    let subjectcount = 0
    let topiccount = 0
    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'test' // Query name,

        ],
    });
    const query1 = useQuery(Get_test, {
        variables: {
            "_id": id,
        },
    });
    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function () {
            navigate(`/testlayer/testperformance/${id}`);
            window.history.pushState(null, null, window.location.href);

        };
    }, [navigate]);

    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        console.log(query1.error)
    }
    useEffect(() => {
        setApiData(query1.data)
        applyfilt()
        if (selectData != null) {
            setAll(false)

            if (selectData.text == 'skip') {
                setAttempted(false)
                setUnattempted(true)
                setCorrect(false)
                setIncorrect(false)
                setGuess(false)
                setReview(false)
                applyfilt()
            }
            else if (selectData.text == 'attempt') {
                setAttempted(true)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(false)
                setGuess(false)
                setReview(false)
                applyfilt()
            }
            else if (selectData.text == 'correct') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(true)
                setIncorrect(false)
                setGuess(false)
                setReview(false)
                applyfilt()
            }
            else if (selectData.text == 'incorrect') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(true)
                setGuess(false)
                setReview(false)
                applyfilt()
            }
            else if (selectData.text == 'guess') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(false)
                setGuess(true)
                setReview(false)
                applyfilt()
            }
            else if (selectData.text == 'review') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(false)
                setGuess(false)
                setReview(true)
                applyfilt()
            }
        }
        else {
            all = true
            setAll(true)
        }
    }, [apiData])

    let allData = []

    const applyfilt = () => {
        if (query1.data && query1.data?.test?.progress?.questions.length === 0) {
            allData = []
            query1.data && query1.data?.test?.questions.map((obj, i) => {
                if (unattempted && (query1.data?.test?.progress?.unattemptedQids.includes((obj._id).toString()))) {
                    allData.push(obj)
                }
            })
            setapply(allData)
            hideFilter()
        }
        else {
            allData = []
            let questions = query1.data?.test?.questions
            let attemptedQuestion = query1.data?.test?.progress?.questions
            let unattemptedQuestions = query1.data?.test?.progress?.unattemptedQids
            questions?.map((question, index) => {
                let newObj = { ...question, index: index };
                let obj1 = attemptedQuestion?.find(obj => obj.questionId === question._id)
                if (unattempted && (unattemptedQuestions?.includes((question._id).toString()))) {
                    allData.push(newObj)
                }
                if (attempted && obj1?.questionId?.toString() === (question._id).toString() && obj1?.userAnswer !== '') {
                    allData.push(newObj)
                }
                if (correct && obj1?.questionId?.toString() === (question._id).toString() && question?.answer.includes(obj1?.userAnswer)) {
                    allData.push(newObj)
                }
                if (incorrect && obj1?.questionId?.toString() === (question._id).toString() && !question?.answer.includes(obj1?.userAnswer)) {
                    allData.push(newObj)
                }
                if (guess && obj1?.questionId?.toString() === (question._id).toString() && obj1?.isGuessed === true) {
                    allData.push(newObj)
                }
                if (review && obj1?.questionId?.toString() === (question._id).toString() && obj1?.isReview === true) {
                    allData.push(newObj)
                }
            })

            // query1.data && query1.data?.test?.progress?.questions.map((obj1, index) => {
            //     query1.data && query1.data?.test?.questions.map((obj, i) => {
            //         if (unattempted && (query1.data?.test?.progress?.unattemptedQids.includes((obj._id).toString()))) {
            //             allData.push(obj)
            //         }
            //         if (attempted && obj1.questionId.toString() === (obj._id).toString() && obj1.userAnswer !== '') {
            //             allData.push(obj)
            //         }
            //         if (correct && obj1?.questionId.toString() === (obj._id).toString() && obj.answer.includes(obj1.userAnswer)) {
            //             allData.push(obj)
            //             console.log(i);
            //         }
            //         if (incorrect && obj1?.questionId.toString() === (obj._id).toString() && !obj.answer.includes(obj1.userAnswer)) {
            //             allData.push(obj)
            //         }
            //         if (guess && obj1?.questionId.toString() === (obj._id).toString() && obj1.isGuessed === true) {
            //             allData.push(obj)
            //         }
            //         if (review && obj1?.questionId.toString() === (obj._id).toString() && obj1.isReview === true) {
            //             allData.push(obj)
            //         }
            //     })
            // })

            console.log(allData, "filtered data");
            if (showData == true) {
                all = false
                setAll(false)
                let a = Array.from(new Set(allData.map((item) => item)))
                setapply(a)
            }
            if (showData == false) {
                let a = Array.from(new Set(allData.map((item) => item)))
                let arr = []
                a.map(obj => {
                    if (subjectArr.includes(obj?.subjectDetail?.subjectId) || TopicArr.includes(obj?.subjectDetail?.topicId)) {
                        arr.push(obj)
                    }
                })
                setapply(arr)
            }
            if (query1.data && query1.data.test.progress.subjectStats.length === subjectArr.length) {
                setAllSubject(true)
            }
            if (showData === true) {
                all = false;
                setAll(false);
                let a = Array.from(new Set(allData.map((item) => item)));
                setapply(a);
            }

            if (showData === false) {
                let a = Array.from(new Set(allData.map((item) => item)));
                let arr = [];
                a.map(obj => {
                    if (subjectArr.includes(obj?.subjectDetail?.subjectId) || TopicArr.includes(obj?.subjectDetail?.topicId)) {
                        arr.push(obj);
                    }
                });
                setapply(arr);
            }

            if (query1.data && query1.data.test.progress.subjectStats.length === subjectArr.length) {
                setAllSubject(true);
            }

            hideFilter()
        }
    }
    const subjectcheck = () => {
        setapply(query1.data && query1.data?.test?.questions)
    }
    useEffect(() => {
        subjectcheck()

        if (selectData === null || selectData === undefined) {
            let arr = []
            let topicarr = []
            query1.data && query1.data?.test?.progress?.subjectStats.map(onj => {
                arr.push(onj.subjectId)
                onj.topics.map(o => {
                    topicarr.push(o.topicId)
                    setSubjectArr(arr)
                    setTopicArr(topicarr)

                })
                applyfilt()
            })
            // return
        }
        else if (selectData !== null && selectData?.index == null) {
            if (selectData?.sub === undefined || selectData?.sub === null) {
                let arr = []
                let topicarr = []
                query1.data && query1.data?.test?.progress?.subjectStats.map(onj => {
                    arr.push(onj?.subjectId)
                    onj.topics.map(o => {
                        topicarr.push(o.topicId)
                        setSubjectArr(arr)
                        setTopicArr(topicarr)

                    })
                })
                applyfilt()
                return
            }
            else if (selectData?.sub !== null || selectData?.sub !== undefined) {
                // console.log(selectData?.sub,"vishwa?.sub")
                setAllSubject(false)
                // subjectArr=[]
                setSubjectArr([...subjectArr, selectData?.index]);
                let topicarr = [...TopicArr]
                query1.data && query1.data?.test?.progress?.subjectStats?.map(o => {
                    if (selectData?.index === o.subjectId) {
                        topicarr.push(o.topics[selectData.sub]?.topicId)
                        // if(o.topicId)
                        // topicarr.push(om.topicId)
                        setTopicArr(topicarr)

                    }
                })
                applyfilt()
                return
            }
        }
        else if (selectData !== null && selectData?.index !== null) {
            if (selectData?.sub === null || selectData?.sub === undefined) {
                setAllSubject(false)
                // subjectArr=[]
                setSubjectArr([...subjectArr, query1.data?.test?.progress?.subjectStats[selectData.index]?.subjectId]);
                let topicarr = [...TopicArr]
                query1.data && query1.data?.test?.progress?.subjectStats[selectData.index]?.topics.map(o => {
                    topicarr.push(o.topicId)
                    setTopicArr(topicarr)
                })
                applyfilt()
                return
            }
            else if (selectData?.sub !== null || selectData?.sub !== undefined) {
                setAllSubject(false)
                // subjectArr=[]
                setSubjectArr([...subjectArr, selectData?.index]);
                let topicarr = [...TopicArr]
                query1.data && query1.data?.test?.progress?.subjectStats?.map(o => {
                    if (selectData?.index === o.subjectId) {
                        topicarr.push(o.topics[selectData.sub]?.topicId)
                        // if(o.topicId)
                        // topicarr.push(om.topicId)
                        setTopicArr(topicarr)

                    }
                })
                applyfilt()
                return
            }
        }
    }, []);
    if (query1.loading) {
        return (<><Loader /></>)
    }
    const Reset = () => {
        all = true
        setAll(true)
        setAttempted(true)
        setUnattempted(true)
        setCorrect(true)
        setIncorrect(true)
        setGuess(true)
        setReview(true)
        setAllSubject(true)
        let arr = []
        let topicarr = []
        query1.data && query1.data?.test?.progress?.subjectStats.map(onj => {
            arr.push(onj.subjectId)
            onj.topics.map(o => {
                topicarr.push(o.topicId)
                setSubjectArr(arr)
                setTopicArr(topicarr)

            })
        })
    }

    const checkedbox = (e) => {
        setAll(e.target.checked)
        if (e.target.checked === false) {
            setAttempted(false)
            setUnattempted(false)
            setCorrect(false)
            setIncorrect(false)
            setGuess(false)
            setReview(false)
        }
        else {
            setAttempted(true)
            setUnattempted(true)
            setCorrect(true)
            setIncorrect(true)
            setGuess(true)
            setReview(true)
        }
    }
    const attemptCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setAttempted(e.target.checked)
    }
    const incorrectCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setIncorrect(e.target.checked)

    }
    const correctCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)

        }
        setCorrect(e.target.checked)
    }
    const unattemptedCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setUnattempted(e.target.checked)
    }
    const guessedCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setGuess(e.target.checked)
    }
    const reviewCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setReview(e.target.checked)
    }
    const subjectAll = (e) => {
        setAllSubject(e.target.checked)
        if (e.target.checked) {
            let arr = []
            let topicarr = []
            query1.data && query1.data?.test?.progress?.subjectStats.map(onj => {
                arr.push(onj.subjectId)
                onj.topics.map(o => {
                    topicarr.push(o.topicId)
                    setSubjectArr(arr)
                    setTopicArr(topicarr)

                })
            })
        }
        else {
            let arr = []
            let topicarr = []
            setSubjectArr(arr)
            setTopicArr(topicarr)
        }
    }

    const singleSubject = (e, id, i) => {
        const isSelected = subjectArr.includes(id);
        if (isSelected) {
            setSubjectArr(subjectArr.filter((subjectArr) => subjectArr !== id));
            query1.data && query1.data.test.progress.subjectStats[i].topics.map(o => {
                if (subjectArr.includes(id)) {
                    const rmi = TopicArr.indexOf(o.topicId);
                    if (rmi !== -1) {
                        TopicArr.splice(rmi, 1);
                    }
                    setTopicArr(TopicArr)
                    setAllSubject(false)
                }
            })
        } else {
            setSubjectArr([...subjectArr, id]);
            let topicarr = [...TopicArr]
            query1.data && query1.data.test.progress.subjectStats[i].topics.map(o => {
                topicarr.push(o.topicId)
                setTopicArr(topicarr)
            })
        }
    }
    const singleTopic = (e, id, i) => {
        const isSelected = TopicArr.includes(id);
        if (isSelected) {
            setTopicArr(TopicArr.filter((TopicArr) => TopicArr !== id));
        } else {
            setTopicArr([...TopicArr, id]);
        }
    }




    if (all !== true) {
        if (attempted === true) {
            count = count + 1
        }
        if (unattempted === true) {
            count = count + 1
        }
        if (correct === true) {
            count = count + 1
        }
        if (incorrect === true) {
            count = count + 1

        }
        if (guess === true) {
            count = count + 1

        }
        if (review === true) {
            count = count + 1

        }
    }
    if (all === true) {
        count = count + 6
    }
    query1.data && query1.data.test.progress.subjectStats.map(on => {
        if (on?.topics?.some(item => item.topicId === null) || on.subjectId === null) {
            showData = true
        }
    })
    subjectcount = 0

    return (
        <>
            {
                <div className="main_wrapper">
                    <div className="breadcrumbs">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a>Home</a></li>
                            <li className="breadcrumb-item"><a>Test</a></li>
                            <li className="breadcrumb-item active"><a>View Solutions</a></li>
                        </ul>
                    </div>
                    <section className="videoLayer_wrapper allSolution_wrapper section_side_padding">
                        <div className='row'>
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="subjects_wrapper">
                                    <div className="setting_ttl_wrapper d-flex align-items-baseline">
                                        <figure className="sett_back_arrow">
                                            <Link to={`/testlayer/testperformance/${id}`}>
                                                <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                            </Link>
                                        </figure>
                                        <div className="sett_ttl">
                                            <h5>Result Analysis</h5>
                                            <p>{query1.data && query1.data.test.title}<span>Test</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="recommended_video_wrapper">
                                    <div className="questions_listing">
                                        <div className="listing_hedr d-flex align-items-center">
                                            <div className="ques_list_ttl">
                                                <h6>Questions<span>({apply ? apply.length : 0})</span></h6>
                                            </div>
                                            <div className="filter_ttl">
                                                <span onClick={showFilter}>
                                                    <img src={Icons.Filter} alt="filter" className="img-fluid" /> Apply Filter
                                                </span>
                                            </div>
                                        </div>
                                        <div className="applied_filter">
                                            <h6>filters applied</h6>
                                            <div className="applied_selected">
                                                <ul type="none" className="d-flex align0-items-center flex-wrap">
                                                    <li>
                                                        <div className="selected_filter d-flex align-items-center">
                                                            <p>Status<span>({count})</span></p>
                                                            <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                        </div>
                                                    </li>
                                                    {
                                                        showData !== true &&
                                                        <>
                                                            <li>
                                                                <div className="selected_filter d-flex align-items-center">
                                                                    <p>Subject<span>({subjectArr.length})</span></p>
                                                                    <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="selected_filter d-flex align-items-center">
                                                                    <p>Topic<span>({TopicArr.length})</span></p>
                                                                    <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                                </div>
                                                            </li>
                                                        </>
                                                    }

                                                    {/* <li>
                                                <div className="selected_filter d-flex align-items-center">
                                                    <p>Status<span>(9)</span></p>
                                                    <img src={Icons.CloseItem} alt="" className="img-fluid"/>
                                                </div>
                                            </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="solution_questions">
                                            <ul type="none" className="d-flex align-items-center flex-wrap">
                                                {
                                                    apply && apply.map((d, i) => (
                                                        <li>
                                                            <Link to={`/testlayer/all/${id}/${i}`} state={JSON.stringify(apply)}>
                                                                <div className="solution_body d-flex align-items-center">
                                                                    <figure className="ques_img">Q{d?.index ? (d.index + 1) : (i + 1)}</figure>
                                                                    <div className="ques_body_content">
                                                                        <div className="ques_ttl_wrapper d-flex">
                                                                            <div className="question_ttl">
                                                                                {/* <h6>{d && d.question.questionText}</h6> */}
                                                                                <h6
  dangerouslySetInnerHTML={{ __html: d?.question?.questionText || "" }}
></h6>

                                                                            </div>
                                                                            {/* <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div> */}
                                                                        </div>
                                                                        <div className="course_name d-flex">
                                                                            <div className="course_ttl">
                                                                                <p>{d && d.subjectDetail && d.subjectDetail.subjectName}</p>
                                                                            </div>
                                                                            <div className="course_arrow">
                                                                                <img src={Icons.TestArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))
                                                }
                                                {/* <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            <Modal
                show={filter}
                onHide={hideFilter}
                backdrop="static"
                className="detail_modal apply_filter"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Filter <span onClick={Reset}><img src={Icons.Reload} alt="" className="img-fluid" />Reset Filter</span></h4>
                        {/* <span className="cross_icon">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideFilter}/>
                    </span> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter_status_wrapper">
                        <div className="filter_body">
                            <div className="status_ttl">
                                <h6>Status<span>({count})</span></h6>
                            </div>
                            <div className="status_checkboxes">
                                <div class="custom-control custom-checkbox all_checkbox">
                                    <input type="checkbox" className="custom-control-input" checked={all} id="all" onClick={checkedbox} name="example1" />
                                    <label className="custom-control-label" for="all" >All</label>
                                </div>
                                <div className="filter_checkbox d-flex align-items-center flex-wrap">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={attempted} id="attempt" onClick={attemptCheckedbox} name="example1" />
                                        <label className="custom-control-label" for="attempt" >Attempted</label>
                                        <span></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={correct} id="correct" onClick={correctCheckedbox} name="example1" />
                                        <label className="custom-control-label" for="correct" >Correct</label>
                                        <span className="correct"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={incorrect} id="incorrect" name="example1" onClick={incorrectCheckedbox} />
                                        <label className="custom-control-label" for="incorrect">Incorrect</label>
                                        <span className="incorrect"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={unattempted} id="skip" name="example1" onClick={unattemptedCheckedbox} />
                                        <label className="custom-control-label" for="skip">Skipped</label>
                                        <span className="skip"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={guess} id="guess" name="example1" onClick={guessedCheckedbox} />
                                        <label className="custom-control-label" for="guess">Guessed</label>
                                        <span className="guess"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="review" checked={review} name="example1" onClick={reviewCheckedbox} />
                                        <label className="custom-control-label" for="review">Reviewed</label>
                                        <span className="review"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            showData !== true &&
                            <div className="filter_body select_subject_topics" >
                                <div className="status_ttl">
                                    <h6>Subject & Topics<span>({subjectArr.length + TopicArr.length})</span></h6>
                                </div>
                                <div className="custom_select_filter">
                                    <div className="status_checkboxes select_all_topics">
                                        <div class="custom-control custom-checkbox all_checkbox">
                                            <input type="checkbox" className="custom-control-input" id="all_topics" checked={allsubject} onChange={subjectAll} name="example1" />
                                            <label className="custom-control-label" for="all_topics" >Select All</label>
                                        </div>
                                    </div>
                                    <div className="select_topics_wrapper">
                                        <div id="accordion">
                                            {
                                                query1.data && query1.data?.test?.progress?.subjectStats.map((d, i) => (
                                                    <div className="topics_card">
                                                        <div className="topics_hedr">
                                                            <div class="custom-control custom-checkbox status_checkboxes" data-toggle="collapse" href={`#collapse${i}`}>
                                                                <input type="checkbox" className="custom-control-input" checked={subjectArr.includes(d.subjectId) ? true : false} onChange={(e) => singleSubject(e, d.subjectId, i)} id={`topicName${i}`} name="example1" />
                                                                <label className="custom-control-label" for={`topicName${i}`}>{d.subject && d.subject.subjectName} <span>({d.topics.length} Topics)</span></label>
                                                            </div>
                                                            <span className="sub_arrow">
                                                                <img src={Icons.BookmarkArrow} alt="" className="img-fluid" />
                                                            </span>
                                                        </div>
                                                        <div id={`collapse${i}`} class="collapse show" data-parent="#accordion">
                                                            <div className="topics_body_content status_checkboxes">

                                                                {
                                                                    d && d.topics.map(obj => (
                                                                        d.subject && d?.subject?.qbTopics.map((da, i) => (
                                                                            obj.topicId === (da._id) &&
                                                                            <div class="custom-control custom-checkbox all_checkbox">
                                                                                <input type="checkbox" className="custom-control-input" checked={TopicArr.includes(da._id) ? true : false} onChange={(e) => singleTopic(e, da._id, i)} id={`topics${i}`} name="example1" />
                                                                                <label className="custom-control-label" for={`topics${i}`}>{da.title}</label>
                                                                            </div>
                                                                        ))
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={hideFilter}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={applyfilt}>Apply</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}